/**
 * Ob eine Bestellung gezeigt bzw. geoeffnet werden darf. Bis zum KI-Zugang (Stufe 1) stand die Regel
 * in `components/Drawer/Drawer.tsx`; sie ist verschoben, weil der Server dieselbe Regel braucht und
 * `lib/` ohne Komponenten auskommen muss. `Drawer.tsx` fuehrt den Namen als Re-Export weiter.
 */
import type { Order } from "./types.ts";

/** In JTL geloeschte Bestellungen bleiben im Audit sichtbar, duerfen aber nicht mehr geoeffnet werden. */
export function darfBestellungOeffnen(order: Order | undefined): order is Order {
  return order !== undefined && order.deleted_in_jtl !== true;
}
